import img_glasvordach_freitragend from './auswahl/glasvordach_freitragend.svg';

export const glasvordach_freitragend =
    {
        category: 'Glasvordach freitragend',
        product_img: img_glasvordach_freitragend,
        titel: 'Glasvordach freitragend',
        price: 350,
        wrapper: [{wrapper1: 0, wrapper2: 0, wrapper3: 0}],
        steps: [
            [[false], [false], [false]],
            {
                visited: [0],
                active_steps: []
            }
        ],
        dimensions: [
            {
            width: '',
            width_param: '40 - 600',
            height: '',
            height_param: '20 - 115'
          },
        ],
        glasart: '',
        pfosten: '',
        data_description: [
            {
                image: '',
                file: '',
                description: '',
                isUploadData: false
            }
        ],
        allVisitedSteps: false,
        is_merkliste: false
    }
